const Y_PORTERO = 90;
const Y_LIBERO = 75;
const Y_CENTRALES = 70;
const Y_LATERALES = 68;
const Y_CARRILEROS = 56;
const Y_MEDIOS = 45;
const Y_INTERIORES = 40;
const Y_MEDIAPUNTA = 35;
const Y_EXTREMOS = 18;
const Y_DELANTERO = 14;

const X_LATERAL_IZQ = 13;
const X_INTERIOR_IZQ = 25;
const X_CENTRAL_IZQ = 37;
const X_CENTRO = 50;
const X_CENTRAL_DER = 63;
const X_INTERIOR_DER = 75;
const X_LATERAL_DER = 87;

export const FORMACIONES = {
  F11: {
    '4-3-3': {
      nombre: '4-3-3',
      posiciones: [
        { id: 'Portero', label: 'POR', x: X_CENTRO, y: Y_PORTERO },
        { id: 'Lateral izquierdo', label: 'LI', x: X_LATERAL_IZQ, y: Y_LATERALES },
        { id: 'Central izquierdo', label: 'DFC', x: X_CENTRAL_IZQ, y: Y_CENTRALES },
        { id: 'Central derecho', label: 'DFC', x: X_CENTRAL_DER, y: Y_CENTRALES },
        { id: 'Lateral derecho', label: 'LD', x: X_LATERAL_DER, y: Y_LATERALES },
        { id: 'Pivote', label: 'MCD', x: X_CENTRO, y: Y_MEDIOS },
        { id: 'Interior izquierdo', label: 'MC', x: X_INTERIOR_IZQ, y: Y_INTERIORES },
        { id: 'Interior derecho', label: 'MC', x: X_INTERIOR_DER, y: Y_INTERIORES },
        { id: 'Extremo izquierdo', label: 'EI', x: X_LATERAL_IZQ, y: Y_EXTREMOS },
        { id: 'Delantero centro', label: 'DC', x: X_CENTRO, y: Y_DELANTERO },
        { id: 'Extremo derecho', label: 'ED', x: X_LATERAL_DER, y: Y_EXTREMOS },
      ],
    },
    '4-4-2': {
      nombre: '4-4-2',
      posiciones: [
        { id: 'Portero', label: 'POR', x: X_CENTRO, y: Y_PORTERO },
        { id: 'Lateral izquierdo', label: 'LI', x: X_LATERAL_IZQ, y: Y_LATERALES },
        { id: 'Central izquierdo', label: 'DFC', x: X_CENTRAL_IZQ, y: Y_CENTRALES },
        { id: 'Central derecho', label: 'DFC', x: X_CENTRAL_DER, y: Y_CENTRALES },
        { id: 'Lateral derecho', label: 'LD', x: X_LATERAL_DER, y: Y_LATERALES },
        { id: 'Volante izquierdo', label: 'MI', x: X_LATERAL_IZQ, y: Y_INTERIORES },
        { id: 'Interior izquierdo', label: 'MC', x: X_CENTRAL_IZQ, y: Y_MEDIOS },
        { id: 'Interior derecho', label: 'MC', x: X_CENTRAL_DER, y: Y_MEDIOS },
        { id: 'Volante derecho', label: 'MD', x: X_LATERAL_DER, y: Y_INTERIORES },
        { id: 'Delantero izquierdo', label: 'DC', x: X_INTERIOR_IZQ, y: Y_DELANTERO },
        { id: 'Delantero derecho', label: 'DC', x: X_INTERIOR_DER, y: Y_DELANTERO },
      ],
    },
    '4-2-3-1': {
      nombre: '4-2-3-1',
      posiciones: [
        { id: 'Portero', label: 'POR', x: X_CENTRO, y: Y_PORTERO },
        { id: 'Lateral izquierdo', label: 'LI', x: X_LATERAL_IZQ, y: Y_LATERALES },
        { id: 'Central izquierdo', label: 'DFC', x: X_CENTRAL_IZQ, y: Y_CENTRALES },
        { id: 'Central derecho', label: 'DFC', x: X_CENTRAL_DER, y: Y_CENTRALES },
        { id: 'Lateral derecho', label: 'LD', x: X_LATERAL_DER, y: Y_LATERALES },
        { id: 'Interior izquierdo', label: 'MCD', x: X_INTERIOR_IZQ, y: Y_MEDIOS + 2 },
        { id: 'Interior derecho', label: 'MCD', x: X_INTERIOR_DER, y: Y_MEDIOS + 2 },
        { id: 'Extremo izquierdo', label: 'MI', x: X_LATERAL_IZQ, y: Y_MEDIAPUNTA - 10 },
        { id: 'Mediapunta', label: 'MCO', x: X_CENTRO, y: Y_MEDIAPUNTA },
        { id: 'Extremo derecho', label: 'MD', x: X_LATERAL_DER, y: Y_MEDIAPUNTA - 10 },
        { id: 'Delantero centro', label: 'DC', x: X_CENTRO, y: Y_DELANTERO },
      ],
    },
    '3-5-2': {
      nombre: '3-5-2',
      posiciones: [
        { id: 'Portero', label: 'POR', x: X_CENTRO, y: Y_PORTERO },
        { id: 'Central izquierdo', label: 'DFC', x: X_INTERIOR_IZQ, y: Y_LIBERO },
        { id: 'Central centro', label: 'DFC', x: X_CENTRO, y: Y_CENTRALES },
        { id: 'Central derecho', label: 'DFC', x: X_INTERIOR_DER, y: Y_LIBERO },
        { id: 'Carrilero izquierdo', label: 'CAI', x: X_LATERAL_IZQ, y: Y_CARRILEROS },
        { id: 'Interior izquierdo', label: 'MC', x: X_INTERIOR_IZQ, y: Y_MEDIAPUNTA },
        { id: 'Pivote', label: 'MCD', x: X_CENTRO, y: Y_MEDIAPUNTA },
        { id: 'Interior derecho', label: 'MC', x: X_INTERIOR_DER, y: Y_MEDIAPUNTA },
        { id: 'Carrilero derecho', label: 'CAD', x: X_LATERAL_DER, y: Y_CARRILEROS },
        { id: 'Delantero izquierdo', label: 'DLI', x: X_INTERIOR_IZQ, y: Y_DELANTERO },
        { id: 'Delantero derecho', label: 'DLD', x: X_INTERIOR_DER, y: Y_DELANTERO },
      ],
    },
    '3-4-3': {
      nombre: '3-4-3',
      posiciones: [
        { id: 'Portero', label: 'POR', x: X_CENTRO, y: Y_PORTERO },
        { id: 'Central izquierdo', label: 'DFC', x: X_INTERIOR_IZQ, y: Y_CENTRALES },
        { id: 'Central centro', label: 'DFC', x: X_CENTRO, y: Y_CENTRALES },
        { id: 'Central derecho', label: 'DFC', x: X_INTERIOR_DER, y: Y_CENTRALES },
        { id: 'Carrilero izquierdo', label: 'CAI', x: X_LATERAL_IZQ, y: Y_MEDIOS },
        { id: 'Interior izquierdo', label: 'MC', x: X_CENTRAL_IZQ, y: Y_MEDIOS },
        { id: 'Interior derecho', label: 'MC', x: X_CENTRAL_DER, y: Y_MEDIOS },
        { id: 'Carrilero derecho', label: 'CAD', x: X_LATERAL_DER, y: Y_MEDIOS },
        { id: 'Extremo izquierdo', label: 'EI', x: X_LATERAL_IZQ, y: Y_EXTREMOS },
        { id: 'Delantero centro', label: 'DC', x: X_CENTRO, y: Y_DELANTERO },
        { id: 'Extremo derecho', label: 'EXD', x: X_LATERAL_DER, y: Y_EXTREMOS },
      ],
    },
  },

  F7: {
    '3-2-1': {
      nombre: '3-2-1',
      posiciones: [
        { id: 'Portero', label: 'POR', x: X_CENTRO, y: Y_PORTERO },
        { id: 'Defensa izquierdo', label: 'DFI', x: X_INTERIOR_IZQ - 5, y: Y_LATERALES },
        { id: 'Defensa central', label: 'DFC', x: X_CENTRO, y: Y_LATERALES },
        { id: 'Defensa derecho', label: 'DFD', x: X_INTERIOR_DER + 5, y: Y_LATERALES },
        { id: 'Mediocampista izquierdo', label: 'MC', x: X_INTERIOR_IZQ, y: Y_INTERIORES },
        { id: 'Mediocampista derecho', label: 'MC', x: X_INTERIOR_DER, y: Y_INTERIORES },
        { id: 'Delantero', label: 'DC', x: X_CENTRO, y: Y_DELANTERO },
      ],
    },
    '3-1-2': {
      nombre: '3-1-2',
      posiciones: [
        { id: 'Portero', label: 'POR', x: X_CENTRO, y: Y_PORTERO },
        { id: 'Defensa izquierdo', label: 'DFI', x: X_INTERIOR_IZQ - 5, y: Y_LATERALES },
        { id: 'Defensa central', label: 'DFC', x: X_CENTRO, y: Y_LATERALES },
        { id: 'Defensa derecho', label: 'DFD', x: X_INTERIOR_DER + 5, y: Y_LATERALES },
        { id: 'Mediocampista central', label: 'MC', x: X_CENTRO, y: Y_INTERIORES },
        { id: 'Delantero izquierdo', label: 'DC', x: X_INTERIOR_IZQ, y: Y_DELANTERO },
        { id: 'Delantero derecho', label: 'DC', x: X_INTERIOR_DER, y: Y_DELANTERO },
      ],
    },
    '2-3-1': {
      nombre: '2-3-1',
      posiciones: [
        { id: 'Portero', label: 'POR', x: X_CENTRO, y: Y_PORTERO },
        { id: 'Defensa izquierdo', label: 'DFI', x: X_CENTRAL_IZQ, y: Y_LATERALES },
        { id: 'Defensa derecho', label: 'DFD', x: X_CENTRAL_DER, y: Y_LATERALES },
        { id: 'Mediocampista izquierdo', label: 'MI', x: X_INTERIOR_IZQ - 5, y: Y_INTERIORES },
        { id: 'Mediocampista central', label: 'MC', x: X_CENTRO, y: Y_INTERIORES },
        { id: 'Mediocampista derecho', label: 'MD', x: X_INTERIOR_DER + 5, y: Y_INTERIORES },
        { id: 'Delantero', label: 'DC', x: X_CENTRO, y: Y_DELANTERO },
      ],
    },
    '2-2-2': {
      nombre: '2-2-2',
      posiciones: [
        { id: 'Portero', label: 'POR', x: X_CENTRO, y: Y_PORTERO },
        { id: 'Defensa izquierdo', label: 'DFI', x: X_INTERIOR_IZQ, y: Y_LATERALES },
        { id: 'Defensa derecho', label: 'DFD', x: X_INTERIOR_DER, y: Y_LATERALES },
        { id: 'Mediocampista izquierdo', label: 'MC', x: X_INTERIOR_IZQ, y: Y_INTERIORES },
        { id: 'Mediocampista derecho', label: 'MC', x: X_INTERIOR_DER, y: Y_INTERIORES },
        { id: 'Delantero izquierdo', label: 'DC', x: X_INTERIOR_IZQ, y: Y_DELANTERO },
        { id: 'Delantero derecho', label: 'DC', x: X_INTERIOR_DER, y: Y_DELANTERO },
      ],
    },
    '1-3-2': {
      nombre: '1-3-2',
      posiciones: [
        { id: 'Portero', label: 'POR', x: X_CENTRO, y: Y_PORTERO },
        { id: 'Defensa central', label: 'DFC', x: X_CENTRO, y: Y_LATERALES },
        { id: 'Mediocampista izquierdo', label: 'MI', x: X_INTERIOR_IZQ, y: Y_MEDIOS },
        { id: 'Mediocampista central', label: 'MC', x: X_CENTRO, y: Y_MEDIOS },
        { id: 'Mediocampista derecho', label: 'MD', x: X_INTERIOR_DER, y: Y_MEDIOS },
        { id: 'Delantero izquierdo', label: 'DC', x: X_INTERIOR_IZQ, y: Y_DELANTERO },
        { id: 'Delantero derecho', label: 'DC', x: X_INTERIOR_DER, y: Y_DELANTERO },
      ],
    },
  },
};
